import React from 'react';
import { Countdown } from './Countdown';
import { OfferSelector } from './OfferSelector';
export const FinalCTA = () => {
  return <section className="py-16 bg-cream border-t border-brand-orange/10" data-id="element-83">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-84">
        <div className="text-center mb-8" data-id="element-85">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-gray-900 mb-2" data-id="element-86">
            No dejes pasar esta oportunidad
          </h2>
          <p className="text-base text-gray-600 mb-5" data-id="element-87">Termina en</p>
          <div className="max-w-md mx-auto mb-8" data-id="element-88">
            <Countdown data-id="element-89" />
          </div>
        </div>

        <OfferSelector data-id="element-90" />
      </div>
    </section>;
};